<template>
  <v-app>
    <v-main>
      <v-container fluid class="auth-container">
      <v-row no-gutters class="auth-container__box" justify="center">
        <div class="auth-container__wrapper">
          <router-view/>
        </div>
      </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'auth'
}
</script>

<style lang="scss" scoped>
.auth-container {
  height: 100vh;

  &__box {
    height: 100%;
  }

  &__wrapper {
    max-width: 480px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
  }
}
</style>
